module.exports = __webpack_public_path__ + "static/media/timerBackground.14204c68.svg";